module.exports = {
	"1": "1",
	"2": "2",
	"CHAPTER": "Chapter",
	"TOTAL_VIDEOS": "Total Videos",
	"VIDEO_LESSONS": "Video Lessons",
	"KEEP_FREE_VERSION": "Keep Free Version!",
	"GO_PREMIUM": "Go Premium!",
	"Q": "Q.",
	"N": "N.",
	"CHANGE_READING": "Change Reading",
	"CHANGE_QUESTIONS": "Change Question",
	"CHANGE_NOTES": "Change Notes",
	"OPEN_CALCULATOR": "Open Calculator",
	"CHANGE_CHAPTER": "Change Chapter",
	"SUBSCRIBE_FOR_3000_PRACTICE_QUESTIONS": "Subscribe for 3,000 practice questions",
	"SUBSCRIBE_FOR_4000_PRACTICE_QUESTIONS": "Subscribe for 2,000 Practice Questions",
	"SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS": "Subscribe for 1,500 practice questions",
	"SUBSCRIBE": "Subscribe",
	"GO_TO_VIDEOS": "Go To Videos",
	"ORDER_ID": "Order ID",
	"NAME": "Name",
	"EMAIL": "Email",
	"PAYMENT_METHOD": "Payment Method",
	"THANK_YOU_FOR_YOUR_ORDER": "Thank You for your Order!",
	"PRICE": "Price",
	"DISCOUNT": "Discount",
	"EXPIRED": "Expired",
	"LIFETIME_VALID": "Lifetime valid",
	"ACTIVE": "Active",
	"SUBSCRIPTION_DETAIL": "Package Details",
	"MONTHLY_SUBSCRIPTION_DETAIL": "Subscription Details",
	"GO_TO_PROFILE": "Go to profile",
	"ID": "Id",
	"EXAM_NAME": "Exam Name",
	"PACKAGE": "Package",
	"EXPIRY_DATE": "Expiry Date",
	"STATUS": "Status",
	"READ_MORE": "Read More",
	"PICK_YOUR_EXAM": "Pick Your Exam Plan",
	"GO_BACK_TO_EXAMS": "Go Back To Exams",
	"OK": "OK",
	"VIEW_LIST": "View List",
	"Percentile_20": "20th Percentile",
	"Percentile_80": "80th Percentile",
	"BEGIN_CHAPTER": "Begin Chapter",
	"CHANGE_TOPIC": "Change Topic",
	"CHANGE_QUESTION": "Change Question",
	"READING": "Reading",
	"ACTION": "Action",
	"QUESTIONS": "Questions",
	"DATE": "Date",
	"RECOVER": "Recover",
	"VIEW": "View",
	"CREATE_QUIZ": "Create Quiz",
	"CONTENT": "Content",
	"ALL_CHAPTERS": "All Chapters",
	"ABANDONED_QUIZZES": "Abandoned Quizzes",
	"LENGTH": "Length",
	"COMPLETED_QUIZZES": "Completed Quizzes",
	"TOTAL_READINGS": "Total Readings",
	"FREE_QUESTIONS": "Free Questions",
	"PREMIUM_QUESTIONS": "Premium Questions",
	"CFA_LEVEL_I_QUESTION_BANK": "Question Bank",
	"CHANGE_PASSWORD": "Change Password",
	"MY_SAVED_QUESTIONS": "My Saved Questions",
	"MY_SAVED_NOTES": "My Saved Notes",
	"MY_SAVED_VIDEOS": "My Saved Videos",
	"MY_SAVED": "My Saved Items/Flashcards",
	"MY_SAVED_ITEM_WITH_FLASH_CARD": "My Saved Items/Flashcards",
	"MY_FLASHCARDS": "My Flashcards",
	"MY_REPORTS": "My Reports",
	"ORDER_HISTORY": "Order History",
	"PROFILE_INFO": "Profile Info",
	"EXAM_LOCATION": "Exam Location",
	"AGE": "Age",
	"OCCUPATION": "Occupation",
	"EDUCATION": "Education",
	"UPDATE_PROFILE": "Update Profile",
	"ORDERS": "Orders",
	"ORDERS_History": "Order History",
	"PAYMENT_TYPE": "Payment type",
	"PAYMENT_STATUS": "Payment Status",
	"ORDER_DATE": "Order Date",
	"YOUR_ORDER": "Your Order",
	"Order_Details": "Order Details",
	"GO_TO_HISTORY": "Go to history",
	"TOTAL": "Total",
	"TOTAL_NOTES": "Total Notes",
	"NOTES": "Notes",
	"READY_FOR_PRINT": "Ready For Print",
	"CFA_LEVEL_I_QUIZZES": "Quizzes",
	"CFA_LEVEL_I_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
	"NO_SAVED_QUESTIONS_FOR_LEVEL_I": "No Saved Questions For Level I",
	"QUESTION_ID": "Question ID",
	"TOPIC": "Topic",
	"NO_SAVED_QUESTIONS_FOR_LEVEL_II": "No Saved Questions For Level II",
	"NO_SAVED_NOTES_FOR_LEVEL_I": "No Saved Notes For Level I",
	"NO_SAVED_NOTES_FOR_LEVEL_II": "No Saved Notes For Level II",
	"NO_SAVED_VIDEO_FOR_LEVEL_I": "No Saved Video For Level I",
	"NO_SAVED_VIDEO_FOR_LEVEL_II": "No Saved Video For Level II",
	"PICK_THE_QUESTION_YOU_WANT_TO_REVIEW": "Pick the question you want to review",
	"PICK_THE_NOTES_YOU_WANT_TO_REVIEW": "Pick the notes you want to review",
	"PICK_THE_VIDEO_YOU_WANT_TO_REVIEW": "Pick the video you want to review",
	"LEVEL_I": "LEVEL I",
	"LEVEL_II": "LEVEL II",
	"ALERT": "Alert",
	"READINGS": "Readings",
	"QUESTION_BANK": "Question Bank",
	"FRM_LEVEL_I_TOPICS": "FRM Part I - Topics",
	"FRM_LEVEL_II_TOPICS": "FRM Part II - Topics",
	"FRM_LEVEL_I_QUIZZES": "FRM Part I Quizzes",
	"FRM_LEVEL_II_QUIZZES": "FRM Part II Quizzes",
	"SOA_P_QUIZZES": "Quizzes",
	"SOA_FM_QUIZZES": "Quizzes",
	"SOA_IFM_QUIZZES": "Quizzes",
	"CODE_OF_ETHICS_AND_STANDARDS_OF_PROFESSIONAL_CONDUCT": "Code of Ethics and Standards of Professional Conduct",
	"READ_CHAPTER": "Read Chapter",
	"CANCEL": "Cancel",
	"COMMENT": "Comment",
	"UPDATE_COMMENT": "Update Comment",
	"YOU_CAN_USE_THE_COMMENT_SECTION_TO_ASK_A_QUESTION_OR_TO_SHOW_HOW_YOU_SOLVED_THE_PROBLEM_Dont_hesitate_to_share_your_thoughts_it_could_help_other_candidates": "You can use the comment section to ask a question or to show how you solved the problem. Don't hesitate to share your thoughts, it could help other candidates!",
	"FLASHCARD": "Flashcard",
	"CREATE": "Create",
	"FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study": "Flashcards only show up to you. This is a simple way to take notes while you study!",
	"FRM_NOTES": "Notes",
	"FRM_PART_I_CHAPTERS": "FRM Part I",
	"FRM_PART_II_CHAPTERS": "FRM Part II",
	"TOTAL_QUESTIONS": "Total Questions",
	"PRINT": "Print",
	"FRM_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
	"NO_SAVED_FLASHCARDS_FOR_LEVEL_I": " No Saved Flashcards For Level I",
	"NO_FLASHCARDS_FOR_LEVEL_II": "No Flashcards For Level II",
	"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW": "Pick the flashcard you want to review",
	"DELETE": "Delete",
	"NO_FLASHCARDS": "No Flashcards",
	"NO_SAVED_QUESTIONS": "No Saved Questions",
	"NO_SAVED_NOTES": "No Saved Notes",
	"NO_SAVED_VIDEO": "No Saved Video",
	"NO_REPORTS": "No Reports",
	"MY_FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
	"FROM": "From",
	"TO": "To",
	"QUESTION_PROGRESS": "Questions Progress",
	"LABELS": "labels",
	"DATASETS": "datasets",
	"A": "A",
	"B": "B",
	"C": "C",
	"D": "D",
	"E": "E",
	"VALIDATE": "Validate",
	"FLAG_QUESTION": "Flag Question",
	"THE_CORRECT_ANSWER_IS": "The correct answer is ",
	"QUIZ_ID": "Quiz ID",
	"BACK_TO_SUMMARY": "Back to Summary",
	"CFA_LEVEL_I_PREMIUM_PACKAGE": "CFA Level I - Premium Package",
	"TOTAL_TIME:": "Total Time:",
	"CREATE_NEW_QUIZ": "Create New Quiz",
	"SUMMARY": "Summary",
	"MINUTE": "Minute",
	"BEFORE_STARTING": "Before Starting",
	"ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER": "1. Once a question is validated, it is impossible to change your answer.",
	"YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS": "2. You can always come back to this page to view the questions left unanswered or to navigate through the questions.",
	"IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS": "3. If you requested a timer, we strongly discourage you to stop it during the quiz as time management is a key factor for success.",
	"YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER": "4. You can always use the flashcard or the save question tools to take some notes for later.",
	"WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS": "5. We encourage you to leave your methodology in the comments section to help other users.",
	"YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION": "6. You can leave the quiz and come back later. It will always stay available in the abandoned quizzes section.",
	"EXAMPLE": "Example",
	"NO_ANSWER": "No Answer",
	"CORRECT_ANSWER": "Correct Answer",
	"WRONG_ANSWER": "Wrong Answer",
	"ACTIONS": "Actions",
	"MY_FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
	"NOTES_PROGRESS": "Notes Progress",
	"GO_BACK_TO_PROFILE": "Go Back to Profile",
	"OLD_PASSWORD": "Old Password",
	"NEW_PASSWORD": "New Password",
	"CONFIRM_NEW_PASSWORD": "Confirm New Password",
	"UPDATE_PASSWORD": "Update Password",
	"YOUR_CART": "Your Cart",
	"PLEASE_VERIFY_THE_EXAM_AND_LEVEL_FOR_YOUR_PURCHASE": "Please verify the exam and level before you proceed to pay.",
	"PRICE($)": "Price($)",
	"PAYABLE_TODAY": "Payable today",
	"$": "$",
	"HAVE_A_PROMOTIONAL_CODE": "Have a Promotional Code",
	"APPLY": "Apply",
	"ADD_SUBSCRIPTION": "Add Subscription",
	"PROCEED_TO_PAY": "Proceed to pay",
	"PICK_YOUR_PAYMENT": "Select your Payment Method",
	"PAYMENT_WITH_ALIPAY": "Payment With AliPay",
	"PAY_WITH_ALIPAY": "Pay With Alipay",
	"PAY_WITH_CARD": "Pay with Debit or Credit Card",
	"FLASH_CARD": "Flash Card",
	"ADDONS": "Addons",
	"BUY": "BUY",
	"NO_PACKAGE_FOUND": "No Package Found",
	"ALL_EXAMS": "All Exams",
	"YOURS_ANSWER": "Your Answers",
	"SCORE": "Summary",
	"GRAPH": "Detailed Score",
	"TOTAL_TIME": "Total Time",
	"CONTINUE": "Continue",
	"BEGIN": "Begin",
	"QUIZ_ID:": "Quiz ID:",
	"CASES": "Cases",
	"BEGIN_CASES": "Begin Cases",
	"CASE_STUDIES": "Case Studies",
	"CASE_NAME": "Case Name",
	"THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY": "This case is available for Premium members only",
	"CASE_STUDY": "Case Study",
	"CHANGE_CASES": "Change Cases",
	"CFA_LEVEL_I_MY_DASHBOARD": "Dashboard",
	"CFA_LEVEL_I_2022_DASHBOARD": "CFA Level I Dashboard",
	"CFA_LEVEL_I_2023_DASHBOARD": "CFA Level I Dashboard",
	"CFA_LEVEL_II_2023_DASHBOARD": "CFA Level II Dashboard",
	"CFA_LEVEL_II_2022_DASHBOARD": "CFA Level II Dashboard",
	"CFA_LEVEL_II_MY_DASHBOARD": "Dashboard",
	"PERFORMANCE": "Performance",
	"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW:": "Pick the flashcard you want to review:",
	"DASHBOARD": "Dashboard",
	"CFA_LEVEL_II_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
	"CFA_LEVEL_II_QUESTION_BANK": "Question Bank",
	"CFA_LEVEL_II_QUIZZES": "Quizzes",
	"CFA_LEVEL_III_MY_DASHBOARD": "CFA Level III Dashboard",
	"CFA_LEVEL_III_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
	"CFA_LEVEL_III_QUESTION_BANK": "Question Bank",
	"CFA_LEVEL_III_QUIZZES": "Quizzes",
	"FREE": "Free",
	"UPGRADE_ACCOUNT": "Upgrade Account",
	"PREMIUM": "Premium",
	"NO_RECORDS_FOUND": "No Records Found",
	"BACK_TO_VIDEOS": "Back to Videos",
	"FLAG_VIDEO": "Flag Video",
	"GO_TO_NOTES": "Go to Notes",
	"GO_TO_PRACTICE_QUESTIONS": "Go To Practice Questions",
	"QUESTION": "Question",
	"QUIZZES": "Quizzes",
	"BEGIN_NOTES_CHAPTER": "Begin Notes Chapter",
	"CHAPTER_READINGS": " Chapter  Readings",
	"DASHBOARD_GO_TO_PROFILE": "Dashboard Go to Profile",
	"FREE_CASES": "Free cases",
	"PREMIUM_CASES": "Premium cases",
	"NO_SAVED_FLASHCARDS": "No Saved Flashcard",
	"YOUR_CART_IS_EMPTY": "Your cart is empty",
	"PAY_WITH": "Pay With",
	"GRAPHSCORE": "Score",
	"GRAPHSCOREBOX": "Score box",
	"SCOREBOX": "Score Box",
	"CFACHAPTERWISERESULT": "Your Performance by Topic Area",
	"OVERALLRESULT": "Your Performance on the Exam",
	"YOURSCORE": "Your Score",
	"FRMBookWiseScore": "Your Performance by Topic Area",
	"QUESTIONS_3000": "3,000+ Questions",
	"FULL_LENGTH_PRINTABLE_MOCK_EXAMS_8": "8 Full-Length Printable Mock Exams",
	"UNLIMITED_CUSTOMIZABLE_QUIZZES": "Unlimited Customizable Quizzes",
	"COMPREHENSIVE_STUDY_NOTES": "Comprehensive Study Notes",
	"A_FORMULA_SHEET": "A Formula Sheet",
	"PRIORITY_EMAIL_SUPPORT": "Priority Email Support",
	"AND_YOU_KEEP_YOUR_MEMBERSHIP_UNTIL_YOU_PASS": "...and you keep your membership until you pass!",
	"FORGOT_PASSWORD": "Forgot password?",
	"SIGN_IN": "Sign In",
	"SIGN_UP": "Sign Up",
	"SELECT_EXAM": "Select Exam",
	"CFA_1": "Level I of the CFA® Exam",
	"CFA_1_2021": "Level I of CFA® Exam",
	"CFA_1_2022": "Level I of CFA® Exam",
	"CFA_1_2023": "Level I of the CFA® Exam 2023",
	"CFA_1_2024": "Level I of the CFA® Exam 2024",
	"CFA2_2025_QUIZ_ERROR": "Not enough questions to populate the quiz",
	"CFA_2": "Level II of the CFA® Exam",
	"CFA_2_2023": "Level II of the CFA® Exam 2023",
	"CFA_2_2025": "Level II of the CFA® Exam 2025",
	"CFA_2_2023_2024": "Level II of the CFA® Exam 2023/2024",
	"CFA_3": "Level III of the CFA® Exam",
	"CFA_3_2024": "Level III of the CFA® Exam 2024",
	"FRM_PART_1": "FRM Part I",
	"FRM_PART_2": "FRM Part II",
	"RESET_PASSWORD": "Reset Password",
	"RESEND_MAIL": "Resend Mail",
	"PASSWORD_RESET_SUCCESSFULLY": "Password has been reset successfully",
	"LOGIN": "Login",
	"ENTER_YOUR_EMAIL_ADDRESS": "Enter your email address and we'll send you a recovery link",
	"SUBMIT": "Submit",
	"CHECK_YOUR_EMAIL": "Check your email",
	"RESTE_PASSWORD_LINK": "Reset password link has been sent to your email address",
	"RESEND_EMAIL": "Resend Email",
	"WELCOME_TO_ANALYSTPREP": "Welcome to AnalystPrep",
	"EXTRAS": "extras",
	"ALREADY_SUBSCRIBED": "Already Subscribed",
	"QUIZ": "Quiz",
	"NO_COMMENTS_FOUND": "No Comments Found",
	"PASSWORD": "Password",
	"USERNAME_OR_EMAIL": "Username or Email",
	"CONFIRM_PASSWORD": "Confirm Password",
	"USERNAME": "Username",
	"QUESTION_SETS_150": "150 Question Sets",
	"QUESTION_SETS_120": "120 Question Sets",
	"FULL_LENGTH_PRINTABLE_MOCK_EXAMS": "Full-Length Printable Mock Exams",
	"PAY_WITH_ALIPAY_NORMAL": "Pay With AliPay",
	"PAY_WITH_ALIPAY_CAPITAL": "PAY WITH ALIPAY",
	"PAY_WITH_PAYPAL_NORMAL": "Pay with PayPal",
	"PAY_WITH_PAYPAL_CAPITAL": "PAY WITH PAYPAL",
	"BY": "By",
	"NO_FLASHCARD_FOUND": "No Flash Card Found",
	"SELECT_HERE_NUMBER": "You can select here the number of questions for the quiz.",
	"ALL_INCOMPLETE_QUIZ": "You can see here the list of all incomplete quizes and also you can start the quiz from the point where you left by clicking on Recover link.",
	"SEE_THE_DETAILS": "You can see here the list of all completed quizes and see the details of the answered questions by clicking on View link.",
	"SEPARATE_YOUR_RESULT": "Analyze your results by topic and compare them to a user base of over 50,000 candidates.",
	"YOU_CAN_SEE": " A full progress bar means you have completed all available questions in that specific topic.",
	"Priority_selected": "You can priorities quiz on the basis of below options.",
	"I_WANT_MORE_DETAILS": "I Want More Details",
	"CONFIRM": "Confirm",
	"ARE_YOU_SURE_TO_DELETE_THIS": "Are you sure you want to delete this?",
	"RATE_THIS_QUESTION": "Rate this Question",
	"THAT_SPECIFIC_NOTES": "A full progress bar means you have completed all available study notes in that specific topic.",
	"ERROR": "Error",
	"CONFIRMATION_BOX": "Confirmation Box",
	"MARK_AS_READ": "Mark as Read",
	"SAVE_QUESTION": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
	"SAVE_NOTES": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
	"SAVE_VIDEO": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
	"MESSAGE": "Message",
	"READING_NOT_FOUND": "Reading Not Found",
	"MAY_ENTER_COUPON": "You may enter coupon code, partner code.",
	"MOCK_EXAMS": "Mock Exams",
	"VIDEOS": "Videos",
	"FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
	"FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
	"FRM_EXAM_I_QUIZZES": "FRM Part I Quizzes",
	"FRM_EXAM_II_QUIZZES": "FRM Part II Quizzes",
	"FRM_EXAM_I_VIDEOS": "Videos",
	"NEW_MAIL_ARRIVED": "new mail arrived",
	"CFA_LEVEL_I": "CFA Level I",
	"CFA_LEVEL_I_2021": "CFA Level I 2021",
	"CFA_LEVEL_I_2022": "CFA Level I 2022",
	"CFA_LEVEL_I_2023": "CFA Level I 2023",
	"CFA_LEVEL_I_2024": "CFA Level I 2024",
	"CFA_LEVEL_I_2024_DASHBOARD": "CFA Level I Dashboard",
	"CFA_LEVEL_II": "CFA Level II",
	"CFA_LEVEL_II_2023": "CFA Level II 2023",
	"CFA_LEVEL_II_2021": "CFA Level II 2021",
	"CFA_LEVEL_II_2022": "CFA Level II",
	"CFA_LEVEL_III": "CFA Level III",
	"FRM_EXAMS": "FRM Exams",
	"PROFILE": "Profile",
	"WELCOME": "Welcome",
	"CART": "Cart",
	"SUCCESS": "Success",
	"UPDATE_FAILED": "Update Failed",
	"PROFILE_SUCCESSFULLY_UPDATED": "Profile successfully updated!",
	"QUESTION_NOT_FOUND": "Questions not found",
	"NOTE_NOT_FOUND": "Notes not found",
	"LOGOUT": "Logout",
	"PAY": "Pay",
	"CASE": "Case",
	"STOP": "Stop",
	"Image_size_must_be_greater_than_200_less_than_400": "Image size must be greater than 200x200 in pixel or less than 400x400 inpixel",
	"Image_size_must_not_exceed_200_KB": "Image size must not exceed 200 KB",
	"Password_is_Required": "Password is Required",
	"Password_at_least_6_characters_long": "Password at least 6 characters long",
	"Confirm_Password_is_Required": "Confirm Password is Required",
	"Password_didnt_match": "Password didn't match",
	"Session_has_been_Expired": "Session has been Expired",
	"Email_Id_Not_Exist": " We do not recognize this email address in our system. Please contact support@analystprep.com for help.",
	"Email_Id_Invalid": "Email Id Invalid",
	"Email_is_Required": "Email is Required",
	"User_Name_is_Required": "User Name is Required",
	"Please_enter_atleast_6_characters_in_the_field": "New password must be atleast 6 characters long",
	"Exam_Field_is_Required": "Exam Field is Required",
	"No_Order_History": "No Order History",
	"PAID": "Paid",
	"Result_not_found": "Result not found.",
	"Hide_details": "Hide Details",
	"INCORRECT": "INCORRECT",
	"CORRECT": "CORRECT",
	"Question_Saved": "Question Saved",
	"Notes_Saved": "Notes Saved",
	"Video_Saved": "Video Saved",
	"New_Password_Is_Required": "New Password Is Required",
	"Password_And_Confirm_Password_Is_Required": "New Password and Confirm Password must be same",
	"Notes_not_found": "Notes not found",
	"MARKED_AS_READ": "Marked as Read",
	"RATED": "Rated",
	"VIEW_QUESTION": "View Question",
	"EDIT_REPORT": "Edit report",
	"VIEW_REPORTS_ANSWER": "View Feedback",
	"NO_SUBSCRIPTION_DETAIL": "No Subscription Details",
	"SOA_PROBILITY_DASHBOARD": "Dashboard",
	"List_of_All_Questions_For": "Detailed Stats For",
	"Filter_By": "Filter by",
	"Please_select_Chapter_ID": "Please select Chapter ID",
	"Please_Enter_Number_Only": "Please Enter Number Only",
	"Chapter_ID": "Chapter ID",
	"Reading_ID": "Reading ID",
	"Question_ID": "Question ID",
	"VIDEO_ID": "Video ID",
	"SELECT": "Select",
	"ANSWERED": "Answered",
	"Non_ANSWERED": "Not Answered",
	"No_of_attempts": "No. of Attempts",
	"AVERAGE_SCORE": "Average Score",
	"Passing_Score": "Passing Score",
	"PASSED": "Passed",
	"FAILED": "Failed",
	"Chapter_No": "Chapter No.",
	"READING_No": "Reading No.",
	"Reading_Name": "Reading Name",
	"PASS": "Pass",
	"YES": "Yes",
	"NO": "No",
	"Extensive_Study_Notes": "Extensive Study Notes",
	"Practice_Questions_3000": "3,000+ Practice Questions",
	"Practice_Questions_4000": "4,000+ Practice Questions",
	"Practice_Questions_1250": "1,250 Practice Questions",
	"Practice_Questions_1500_Actuarial": "1,500+ Practice Questions",
	"Mock_Exams_2": "2 Full-Length Mock Exams",
	"FullLength_Mock_Exams_4": "4 Full-Length Mock Exams",
	"FullLength_Mock_Exams_3": "5 Full-Length Mock Exams",
	"Unlimited_Customizable_Quizzes": "Unlimited Customizable Quizzes",
	"Amazing_Chat_Email_Support": "Tutors Answering your Questions via Live Chat",
	"INFORMATION": "Information",
	"Why_should_I_upgrade_my_account": "Why should I Upgrade my Account?",
	"Hours_of_Video_Lessons_40": "40+ Hours of Video Lessons",
	"Hours_of_Video_Lessons_60": "60+ Hours of Video Lessons",
	"Practice_Questions_1500": "500+ Practice Questions",
	"FullLength_Mock_Exams_2": "Essay Questions",
	"DOWNLOAD_PDF": "Download PDF",
	"REPORT": "Report",
	"MARK_THIS_QUESTION_AS_COMPLETED": "Mark as :",
	"COMPLETED": "Completed",
	"NOT_COMPLETED": "Not completed",
	"MARK_THIS_VIGNETTE_QUESTION_AS_COMPLETED": "Mark this Vignette Question as Completed",
	"Mark_this_Question_as_Completed": "Mark this vignette question as completed",
	"Essay_Style_Questions": "Essay Questions",
	"CFA_LEVEL_III_Essay_Style_Questions": "Essay Style Questions",
	"Detailed_Stats": "Detailed Stats",
	"Priorities_By": "Filter Questions",
	"UNANSWERED": "Non-attempted questions",
	"NONE": "No filter",
	"CHANGE_STATUS": "Change Status",
	"Wrong_answers": "Wrong answers",
	"DataDetail": "Data shown is solely based on mock exams attempts where 80% of the questions have been answered in a minimum of 20 minutes.",
	"unanswered_selected": "Prioritize questions you have never attempted followed by questions you answered incorrectly.",
	"wronganswered_selected": "Prioritize questions you answered incorrectly followed by questions you have never attempted.",
	"LANGUAGE": "Language",
	"ENGLISH": "English",
	"CHINESE": "Chinese",
	"Download_PDF": "Download PDF",
	"UPDATE": "Update",
	"CONFIRM_OLD_PASSWORD": "Confirm Old Password",
	"Chapter_Name": "Chapter Name",
	"CHAPTERS": "Chapters",
	"CFA_LEVEL_III_PRINTABLE_ESSAY_QUESTIONS": "Printable Essay Questions",
	"SET_PASSWORD": "Set Password",
	"FORUM": "Forum",
	"DISCUSSIONS": "Discussions",
	"REPLIES": "Replies",
	"GO_TO_APP": "Switch to Study App",
	"GO_TO_FORUM": "Switch to Forum",
	"SAVED_QUESTION": "Question Saved",
	"Executive_Assessment": "Executive Assessment (EA)",
	"SOA_PROBABILITY_QUESTION_BANK": "Question Bank",
	"PROBABILITY": "Probability",
	"SOA_PROBABILITY": "Actuarial Exam P (Probability)",
	"SOA_FINANCIAL": "Actuarial Exam FM (Financial Mathematics)",
	"SOA_INVESTMENT": "Actuarial Exam IFM (Investment and Financial Markets)",
	"ACTUARIAL_PROBABILITY_P": "P (Probability)",
	"ACTUARIAL_FM_QUESTION_BANK": "Question Bank",
	"ACTUARIAL_IFM_QUESTION_BANK": "Question Bank",
	"ACTUARIAL_FM": "FM (Financial Mathematics)",
	"ACTUARIAL_IFM": "IFM (Investment and Financial Markets)",
	"FRM_Part1and2": "FRM Part I & Part II",
	"REPORT_THIS_QUESTION": "Report this question to AnalystPrep's team for review.",
	"GO_TO_QUESTION_BANK": "Go to Question Bank",
	"Notes_ID": "Note ID",
	"Saved_Note": "Saved Note",
	"Question_Bank": "Question Bank",
	"Notes": "Notes",
	"CFA": "CFA Exams",
	"FRM": "FRM Exams",
	"SOA": "Actuarial Exams",
	"TAGS_INFO": "Please click on enter, tab, space, comma to add a tag.",
	"All_prices_are_in_US_dollars_All_sales_are_final": "All prices are in US dollars. All sales are final.",
	"All_sales_are_final": "All sales are final.",
	"COMING_SOON": "Coming Soon",
	"Download_Notes": "Download Notes",
	"Download_Question": "Download Q",
	"Download_Question_Answer": "Download Q/A",
	"COMMENT_TOOLTIP_MESSAGE": "You can use the Comments section to ask a question or to show how you solved the question. Don't hesitate to share your thoughts, as it could help other candidates. Comments will show up on AnalystPrep's forum page.",
	"REPORT_TOOLTIP_MESSAGE": "Report this question to AnalystPrep's team for review.",
	"FLASHCARD_TOOLTIP_MESSAGE": "Flashcards will be visible in the dashboard tab. These are a great way to take notes while studying.",
	"BUY_NOW": "Buy Now",
	"Item_Sets_200": "200 Item Sets",
	"Item_Sets_100": "100 Item Sets",
	"CLOSE": "Close",
	"REPORT_SEND_SUCCESS_MESSAGE": "Your report has been submitted successfully.",
	"I_need_further_help": "I need further help",
	"SUBJECT": "Subject",
	"SEND_REQUEST": "Send Request",
	"GO_TO_ANSWER": "Back",
	"REQUEST_SEND_SUCCESS_MESSAGE": "Your request has been submitted successfully.",
	"GO_TO_MY_LAST_QUESTION_ANSWERED": "Go to my Last Question Answered",
	"GO_TO_MY_LAST_NOTES_READ": "Go to my Last Notes Read",
	"GO_TO_MY_LAST_VIDEO_VIEWED": "Go to my Last Viewed Video",
	"PLEASE_WAIT": "Please Wait",
	"SEND_NOTIFICATIONS_VIA_EMAIL": "Send notifications via email",
	"GOTOLOGIN": "Return to Login.",
	"SIGNUP_Approval_HEADING": "Your account must be verified by an administrator.",
	"SIGNUP_Approval_BODY_1": "You have created your account successfully, but you can not log in yet.",
	"SIGNUP_Approval_BODY_2": "Your registration request has been submitted to the moderators for approval. You will be notified by email when your registration is approved.",
	"FOOTER_MESSAGE": "CFA Institute does not endorse, promote or warrant the accuracy or quality of AnalystPrep. CFA® and Chartered Financial Analyst® are registered trademarks owned by CFA Institute.",
	"PDFContentMessage": "You successfully initiated your export. You'll receive an email notification when your export is ready to download.",
	"PDFDOWNLOAD": "PDF Download",
	"START_STUDY": "Start Studying",
	"TICKET_ID": "Ticket ID",
	"DELETE_FROM_CART": "Delete from Cart",
	"APPSUMO_CODE": "AppSumo Code",
	"Code_is_Required": "AppSumo code is required.",
	"EXISTING_USER_APP_SUMO": "Existing User? Sign In",
	"NEW_USER_APP_SUMO": "New User? Sign Up",
	"ACCOUNT_DELETE": "Delete Account",
	"ARE_YOU_SURE_TO_DELETE_THIS_ACCOUNT": "Are you sure you want to delete your account?",
	"ACCOUNT_DELETE_ALERT": "Delete my account",
	"DeleteAccountMiddleMessage": "<strong>Please Note: </strong> This will <span style='color: #f86c6b;font-weight: bold;' >permanently</span> delete your account including all your data and your activity on the forum.",
	"ACCOUNT_DELETED_SUCCESSFULLY": "Your Account has been successfully deleted.",
	"Download_Q_Cases": "Download QC",
	"Download_QA_Cases": "Download QA/C",
	"FRM_LEVEL_II_LESSONS": "FRM Part II - Video Lessons",
	"FRM_LEVEL_I_LESSONS": "FRM Part I - Video Lessons",
	"CBT_MOCK_EXAM": "CBT Mock Exams",
	"MOCKEXAM": "Mock Exam",
	"INSTRUCTIONS": "Instructions",
	"START": "Start",
	"No_Mock_Exams": "No Mock Exams",
	"SCRORE": "Score",
	"CBT_MOCK_INSTRUCTIONS": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement and Standard VII(A) of the CFA Institute Standards of Professional Conduct.  If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
	"TEST": "Test",
	"Finish_Test": "Finish Test",
	"FRM1_MOCK_LIST": "FRM Part I Computer-Based Testing Mock Exams",
	"FRM2_MOCK_LIST": "FRM Part II Computer-Based Testing Mock Exams",
	"Test_Deleted": "Test Deleted Successfully",
	"BACK": "Back",
	"TOTAL_SCORE": "Total Score",
	"TEST_COMPLETED_IN": "Test Completed In",
	"NEXT": "Next",
	"NO_QUESTION_FOUND": "No Question Found",
	"NO_QUESTION_FOR_THIS_EXAM": "No Questions found for this mock exam",
	"NO_QUESTION_FOR_GRADING": "No Questions found for grading",
	"NO_SCORE_FOUND": "No Score found",
	"MOCK_LIST": "Computer-Based Testing Mock Exams",
	"PRINT_Q_MOCK": "Questions",
	"PRINT_QA_MOCK": "Questions & Answers",
	"TIME_LEFT": "Time Left",
	"FLAG_THIS_QUESTION": "Flag to review later",
	"UNFLAG_THIS_QUESTION": "Unflag question",
	"SECTION_REVIEW": "Section Review",
	"FILTER_BY": "Filter by",
	"CLEAR": "Clear",
	"DELETE_TEST": "Delete Test",
	"VIEW_TEST": "View Test",
	"NO_MOCK_EXAM_FOUND": "No Test Found",
	"INTROTITLE": "Tutorial Introduction",
	"INTROPARA": "<p>The following screens provide a tutorial of the exam software. This will help you become familiar with the software features and is not intended to be a mock exam. This same tutorial will be available to you on exam day. Before attempting any exam questions, take a few minutes to review the tutorial.</p><p>After completing and reviewing the sample exam questions, click the 'Finish Section' button in the top-right corner of the screen.</p><p>Once clicked, a pop-up window will appear confirming that you want to finish the section. Click 'Yes' to submit your answers or 'No' to return to the test.</p><p>Please note that once you finish the section you may not return to the sample exam questions. Any questions that are unanswered or incorrect will not count against your final score.</p>",
	"NEXTTOCONTINUE": "To begin the tutorial, click 'Next' to continue",
	"WELCOMETITLE": "Welcome to the Tutorial",
	"WELCOMEPARA": "<p>This tutorial provides a series of screens that orient you to the computer testing environment. You will be instructed on how to use the mouse and the different parts of the screen.</p><p> Notice the timer at the top of the screen. A similar display will appear during the actual exam. To the left of the screen is a numbered list that shows you where you are in the series of examination questions (or in this case, screens of the tutorial). Other screen features are described later in the tutorial.</p>",
	"NEXTBUTTONCONTINUE": "Click the 'Next' button to continue.",
	"USEMOUSETITLE": "Using the Mouse",
	"USEMOUSEPARA": "<p>The mouse pointer moves when you move the mouse around on a surface. Although it can assume different shapes, the arrow shown above is most common. To point with the mouse, move the pointer until it rests on the desired object. To click on an object, point to it and then quickly press and release the left mouse button.</p>",
	"NAVIGATTITLE": "Navigating Through the Exam",
	"NAVIGATPARA": "<p>Click the <b>'Next'</b> button displayed at the bottom of the screen to move to the next screen or question. Click the <b>'Back'</b> button to move to the previous screen or question.</p><p> In addition to the navigation buttons, you can use the numbered buttons displayed on the left side of the screen. Depending on the number of questions in the section, you may need to click on the down arrow to navigate to additional questions.</p>",
	"NAVIGATBUTTONINFO": "<p>The numbered buttons change appearance to indicate different question states: Current, Attempted, Unattempted, and Flagged.</p><ul><li>The current question will be indicated by an arrow-shaped numbered button.</li><li>For all attempted questions, the numbered button will appear darker in color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
	"TIMEREMAINTITLE": "Time Remaining",
	"TIMEREMAINPARAONE": "<p>The amount of time remaining is displayed at the right of the screen.</p>",
	"TIMEREMAINPARATWO": "<p>Each section of this examination is allocated a specific amount of time, including the Tutorial and Survey. There is also an overall amount of time provided for your full exam appointment. Clicking on the clock will switch between the amount of time remaining in the current section of the exam and the amount of overall time remaining for the full exam appointment.</p><p>The most important time display for you as a test taker is the 'Section Time Remaining.'</p><p>Note that, where applicable, an alert box will appear below the exam clock to signal when 30 minutes, 15 minutes, and 5 minutes remain in the current section.</p>",
	"FLAGTITLE": "Flagging Questions",
	"FLAGPARA": "<p>You can flag a question as a reminder to go back and check your answer or attempt it later. To flag a question, click the <b>'Flag'</b> button displayed at the bottom of the exam screen.</p><p>Any questions that are flagged for review will show a flag icon on the numbered button, as shown below.</p>",
	"FLAGBUTTON": "<p>Click the <b>'Flag'</b> button again to remove the flag.</p>",
	"ANSWERMULTTITLE": "Answering Multiple-Choice Questions",
	"ANSWERMULTPARA": "<p>This examination uses multiple-choice questions. This type of question has one correct answer.</p><p>To complete each multiple-choice question, click on the option that you believe to be the single best answer. Once selected, the option will appear darker in color. To change your response, click on a different option. If you would like to unselect a chosen option, click on it a second time.</p><p><b>Practice answering the multiple-choice question below. Once you have finished practicing, click the 'Next' button to continue.</b></p>",
	"QUESMULTTITLE": "Tallinn is the capital of which country?",
	"ESTONIA": "Estonia",
	"UKRAINE": "Ukraine",
	"BELGIUM": "Belgium",
	"REVIEWTITLE": "Section Review",
	"REVIEWPARA": "<p>During the examination, you can review the status of all questions in a current exam section using the grid icon located in the bottom left corner of the exam screen:</p>",
	"REVIEWPARACLOSE": "<p>To navigate directly to a question, click the corresponding numbered icon. You may also filter your view by unattempted, attempted, and flagged questions. The Section Review can be closed using the <b>'X'</b> icon.</p>",
	"ENDINGEXAMTITLE": "Ending Exam Sections",
	"ENDINGEXAMPARA": "<p>After completing and reviewing all of the questions within a section, you can navigate to the next section by clicking the <b>'Finish Section'</b> button in the top-right corner of the screen. Once clicked, a pop-up window will appear confirming you want to finish the section. Select 'Yes, I would like to finish this section' to submit your answers for that  section and progress to the next section.</p><p>The final section of the test is a short survey. Once you have completed the survey, you can end your session by clicking the <b>'Finish Test'</b> button in the top-right corner of the screen and confirming you would like to finish the test.</p><p>Please note that once you leave a section, you may not return. Any questions that are unanswered or incorrect will not count against your final score.</p>",
	"TUTORIALCONCLUSIONTITLE": "Tutorial Conclusion",
	"TUTORIALCONCLUSIONPARA": "<p>This concludes the tutorial. You can review the tutorial by clicking on the <b>'Back'</b> button to back up one screen at a time, or by using the numbered buttons displayed on the left side of the screen. You may view the tutorial at any point during the examination by clicking on the question mark icon. This icon can be found in the bottom left of the screen once you have begun testing.</p><p>Good luck with the examination.</p>",
	"CLICKSTARTTEST": "Click the 'Start the Test' button to exit the tutorial and begin the examination.",
	"NOT_ATTEMPTED": "Not Attempted",
	"START_TEST": "Start the Test",
	"Incorrect": "Incorrect",
	"Correct": "Correct",
	"TOPIC_WISE_SCORE": "Topic Wise Score",
	"You_Scored": "You Scored",
	"SHOW_MYSCORE": "Show my score by topic",
	"SHOW_GRAPH": "Show my graph",
	"ARE_YOU_SURE_FINISH": "Are you sure you would like to finish the test?",
	"FLAG_POPUP_TEXT": "Some of the questions in this test have been flagged. Are you sure  you would like to finish?",
	"I_ACCEPT_THE_TERMS": "I accept these terms.",
	"NOT_ATTEMPTED_POPUP": "You have not attempted all of the questions on this test.",
	"CHANGE_MOCK": "Change Mock",
	"CBT_MOCK_INSTRUCTIONS_FRM": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement. If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
	"BOOK": "Book",
	"Hours_of_Video_Lessons_30": "30+ Hours of Video Lessons for each Part",
	"Practice_Questions_2000": "2,000 Practice Questions for each Part",
	"SHOW_MYSCORE_Book": "Show my score by book",
	"BOOK_WISE_SCORE": "Book Wise Score",
	"Essential_Summaries": "Essential Summaries",
	"Formula_Sheet": "Formula Sheet",
	"Ratio_Sheet": "Ratio Sheet",
	"Additional_Resources": "Additional Resources",
	"Save_and_Take_Break": "Save and Take a Break",
	"RESUME": "Resume",
	"Section_Introduction": "Section Introduction",
	"Study_Notes": "Study Notes",
	"Click_me_to_highlight": "Click to highlight",
	"Click_me_to_unhighlight": "Click to unhighlight",
	"Strike_Through": "Strikethrough",
	"Correct_Choice": "Mark as correct answer",
	"Incomplete": "Incomplete",
	"HIGHLIGHTINGTEXT": "Highlighting Text",
	"HIGHLIGHTINGPARA": "<p>During the examination, you will be able to highlight question text that you feel is important to refer back to as you progress through the exam. The highlight will remain present as you navigate through the exam, unless you select to remove it.</p><p>To highlight text, click and drag the mouse cursor over the desired text. Click the <b>'Highlight'</b> button, as shown in the image below, that appears after releasing the mouse button. To remove the highlight, click on any area of the highlighted text.</p>",
	"PLEASENOTE": "<p>Please note the highlight feature cannot be applied to text within the answer options.</p>",
	"STRIKINGOUTOPTIONS": "Striking Out Options",
	"STRIKINGOUTOPTIONSPARA": "<p>During the examination, a Strikeout feature is available to help you visually eliminate possible options from consideration. A struck out option will remain present as you progress through the exam, unless you select to remove it.</p><p>Right-click on an option to strike it out. Right-click again to remove the strikeout. Left-click on a struck out option to select it as your response. You may strike out as many or as few items as you like.</p><p><b>Practice using the Strikeout feature below. Once you have finished practicing, click the 'Next' button to continue.</b></p><p>What bird has the largest wingspan of any existing species?</p>",
	"PAUSEEXAM": "Pause Exam",
	"PAUSEEXAMPARA": "<p>While attempting exam you can also pause it for a while to go for a tea break. <b>Once you resume exam the time will be stopped</b>.</p>",
	"Privacy_Policy": "Privacy Policy",
	"PRACTICE_EXAMS": "Practice Exams",
	"PRINT_CASES_QA_MOCK": "Questions & Answers",
	"PRINT_CASES_Q_MOCK": "Questions",
	"Hours_of_Video_Lessons_35": "35+ Hours of Video Lessons",
	"Quant_Questions": "Quant Questions",
	"Verbal_Questions": "Verbal Questions",
	"Integrated_Reasoning_Questions": "Integrated Reasoning Questions",
	"Advanced_Analytics_Dashboard": "Advanced Analytics Dashboard",
	"AskATutor_Questions": "Ask-A-Tutor Questions",
	"SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS": "Subscribe for 1,000 practice questions",
	"VERBAL_PROBLEM": "Verbal Problems",
	"INTEGRATED_REASONING_QUESTIONS": "Integrated Reasoning Questions",
	"PERFORMANCE_BY_AREA": "Performance by Area",
	"QUANT_PROBLEM": "Quantitative Problems",
	"Change_Questions": "Change Question",
	"ESG": "ESG",
	"NAVIGATBUTTONINFOONFINISH": "<p>The numbered buttons change appearance to indicate different answer states: Wrong Answer, Correct Answer, Unanswered and Marks in between 0 and max grade.</p><ul><li>The current answer will be indicated by an arrow-shaped numbered button.</li><li>For all correct answered question, the numbered button will appear in green color.</li><li>For all incorrect answered question, the numbered button will appear in red color.</li><li>For in between 0 to max grading answered question, the numbered button will appear in yellow color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
	"AMOUNT": "Amount",
	"RENEWAL_DATE": "Renewal Date",
	"RECURRING_SUBSCRIPTION_DETAIL": "Recurring Subscription Details"
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/chinese.json
// module id = 1052
// module chunks = 0